<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import recommendMain from "@/pages/account/circle/recommend/recommend-main"
import recommendMulti from "@/pages/account/circle/recommend/recommend-multi"
export default {
  components: {
    recommendMain
  },
  name: "recommend",
  data() {
    return {
      tabData: [
        {
          name: "单个推荐",
          key: "recommendSingle",
          comp: recommendMain,
          status: "2",
        },
        {
          name: "批量推荐",
          key: "recommendMulti",
          comp: recommendMulti,
          status: "1"
        }
      ],
      tabCur: "recommendSingle"
    }
  },
  computed: {
  },
  created() {

  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
  watch: {
  }
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/account/circle/recommend/recommend.vue